// extracted by mini-css-extract-plugin
export default {"background__body":"Background_background__body__ufG0a","background__div":"Background_background__div__FIjSp","background__invisible":"Background_background__invisible__Edd9q"};